import IconPay from '@/icons/IconPay';

const OnlinePaymentProductInfo = () => {
  return (
    <span className="flex select-none items-center gap-2 text-xl">
      <IconPay className="h-[22px] w-[22px] shrink-0" />
      <span className="text-[14px] font-[400] leading-[16.5px] text-[#000000]">Online Payment Only</span>
    </span>
  );
};

export default OnlinePaymentProductInfo;
